/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BaseCommand from './BaseCommand';

/**
 * The ManualOverrideCommandRequest model module.
 * @module model/ManualOverrideCommandRequest
 * @version 1.1.0
 */
class ManualOverrideCommandRequest {
    /**
     * Constructs a new <code>ManualOverrideCommandRequest</code>.
     * The data structure for how to send a manual override command
     * @alias module:model/ManualOverrideCommandRequest
     * @implements module:model/BaseCommand
     */
    constructor(state) {
        BaseCommand.initialize(this);
        ManualOverrideCommandRequest.initialize(this, state);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, state) {
        obj['state'] = state;
    }

    /**
     * Constructs a <code>ManualOverrideCommandRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ManualOverrideCommandRequest} obj Optional instance to populate.
     * @return {module:model/ManualOverrideCommandRequest} The populated <code>ManualOverrideCommandRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ManualOverrideCommandRequest();
            BaseCommand.constructFromObject(data, obj);

            if (data.hasOwnProperty('delay')) {
                obj['delay'] = ApiClient.convertToType(data['delay'], 'String');
            }
            if (data.hasOwnProperty('state')) {
                obj['state'] = ApiClient.convertToType(data['state'], 'String');
            }
            if (data.hasOwnProperty('duration')) {
                obj['duration'] = ApiClient.convertToType(data['duration'], 'String');
            }
            if (data.hasOwnProperty('timeCommanded')) {
                obj['timeCommanded'] = ApiClient.convertToType(data['timeCommanded'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ManualOverrideCommandRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ManualOverrideCommandRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ManualOverrideCommandRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['delay'] && !(typeof data['delay'] === 'string' || data['delay'] instanceof String)) {
            throw new Error("Expected the field `delay` to be a primitive type in the JSON string but got " + data['delay']);
        }
        // ensure the json data is a string
        if (data['state'] && !(typeof data['state'] === 'string' || data['state'] instanceof String)) {
            throw new Error("Expected the field `state` to be a primitive type in the JSON string but got " + data['state']);
        }
        // ensure the json data is a string
        if (data['duration'] && !(typeof data['duration'] === 'string' || data['duration'] instanceof String)) {
            throw new Error("Expected the field `duration` to be a primitive type in the JSON string but got " + data['duration']);
        }

        return true;
    }


}

ManualOverrideCommandRequest.RequiredProperties = ["state"];

/**
 * Delay before activation in ISO-8601 format
 * @member {String} delay
 */
ManualOverrideCommandRequest.prototype['delay'] = undefined;

/**
 * The desired state for the fire defense system
 * @member {module:model/ManualOverrideCommandRequest.StateEnum} state
 */
ManualOverrideCommandRequest.prototype['state'] = undefined;

/**
 * Duration in ISO-8601 format
 * @member {String} duration
 */
ManualOverrideCommandRequest.prototype['duration'] = undefined;

/**
 * The time which the command was made
 * @member {Date} timeCommanded
 */
ManualOverrideCommandRequest.prototype['timeCommanded'] = undefined;


// Implement BaseCommand interface:
/**
 * Duration in ISO-8601 format
 * @member {String} duration
 */
BaseCommand.prototype['duration'] = undefined;
/**
 * The time which the command was made
 * @member {Date} timeCommanded
 */
BaseCommand.prototype['timeCommanded'] = undefined;



/**
 * Allowed values for the <code>state</code> property.
 * @enum {String}
 * @readonly
 */
ManualOverrideCommandRequest['StateEnum'] = {

    /**
     * value: "PRESOAK"
     * @const
     */
    "PRESOAK": "PRESOAK",

    /**
     * value: "ACTIVE"
     * @const
     */
    "ACTIVE": "ACTIVE",

    /**
     * value: "NOT_ACTIVE"
     * @const
     */
    "NOT_ACTIVE": "NOT_ACTIVE",

    /**
     * value: "PRIME"
     * @const
     */
    "PRIME": "PRIME",

    /**
     * value: "FULL_ACTIVE"
     * @const
     */
    "FULL_ACTIVE": "FULL_ACTIVE"
};



export default ManualOverrideCommandRequest;

